import { render } from "./LinuxView.vue?vue&type=template&id=44cfa33a&scoped=true"
import script from "./LinuxView.vue?vue&type=script&lang=js"
export * from "./LinuxView.vue?vue&type=script&lang=js"

import "./LinuxView.vue?vue&type=style&index=0&id=44cfa33a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44cfa33a"]])

export default __exports__